import { NotificationTypeDto } from '@/api/generated';

export type NotificationsDictionariesTranslation = Record<NotificationTypeDto, string>;

export const notificationsDictionariesTranslation: NotificationsDictionariesTranslation = {
  [NotificationTypeDto.DevelopmentPlanInitialized]: 'Plan zainicjowany',
  [NotificationTypeDto.DevelopmentPlanSupervisorAccepted]: 'Przejęty przez przełożonego',
  [NotificationTypeDto.DevelopmentPlanSupervisorRejected]: 'Odrzucony przez przełożonego',
  [NotificationTypeDto.DevelopmentPlanToSupervisorAcceptanceRequested]:
    'Oczekuje na akceptację przełożonego',
  [NotificationTypeDto.DevelopmentPlanRequired]: 'Wymagany plan rozwoju',
  [NotificationTypeDto.DevelopmentPlanInitiationRequired]: 'Zainicjuj plan rozwoju podwładnego',
  [NotificationTypeDto.DevelopmentStepOverdue]: 'Krok planu po terminie',
  [NotificationTypeDto.EmployeeBirthdayAfter]: 'Pracownik obchodził niedawno urodziny',
  [NotificationTypeDto.EmployeeBirthdayToday]: 'Pracownik ma dziś urodziny',
  [NotificationTypeDto.EmployeeBirthdayUpcoming]: 'Zbliżające się urodziny pracownika',
  [NotificationTypeDto.ExamDayStarted]: 'Termin testu się rozpoczyna',
  [NotificationTypeDto.ExamParticipantAdded]: 'Dodano do terminu testu',
  [NotificationTypeDto.IndividualExamStarted]: 'Twój egzamin się rozpoczyna',
  [NotificationTypeDto.SurveyAssigned]: 'Przypisano ankietę',
};
